import './saleForm.scss';

import { Modal } from 'react-bootstrap';
import { FaCartArrowDown, FaCheck, FaTasks, FaWhatsapp } from 'react-icons/fa';

import { StepperFabric } from '../../stepper/StepperFabric';
import CustomModal from '../CustomModal';

export function MedicinePrescriptionModal({
  show,
  addToCart,
  onHide,
}: {
  show: boolean;
  addToCart: () => void;
  onHide: () => void;
}) {
  const steps = [
    {
      title: 'Adicione ao carrinho',
      description: 'Adicione o medicamento ao carrinho.',
      circleProps: { className: 'stepperCircle' },
      icon: <FaCartArrowDown color="white" />,
      step: 1,
    },
    {
      title: 'Finalize seu pedido na loja virtual',
      description: 'Adicione o endereço de entrega ou retirada em loja.',
      circleProps: { className: 'stepperCircle' },

      icon: <FaTasks color="white" />,
      step: 2,
    },
    {
      title: 'Envie a receita pelo WhatsApp',
      circleProps: { className: 'stepperCircle' },
      description: (
        <>
          Clique no botão <strong>Confirmar pedido</strong> para enviar sua receita.
        </>
      ),

      icon: <FaWhatsapp color="white" />,
      step: 3,
    },
    {
      title: 'Pedido concluído!',
      circleProps: { className: 'stepperCircleDone' },
      icon: <FaCheck color="white" />,
      step: 4,
    },
  ];

  return (
    <CustomModal show={show} onHide={onHide} centered>
      <Modal.Header
        className="header pt-3"
        closeButton
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        <div className="d-flex flex-column pb-0 pl-4">
          <h4 style={{ fontWeight: 700, fontFamily: 'Montserrat, sans-serif' }}>
            Medicamento exige o envio antecipado da receita médica
          </h4>
          <p style={{ fontFamily: 'Montserrat, sans-serif' }}>
            A compra desse produto está disponível apenas para <strong>retirada na loja</strong>{' '}
            mediante aprovação e{' '}
            <strong>retenção da receita médica pelo(a) farmacêutico(a).</strong>
          </p>
          <p className="mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Para comprar esse medicamento siga as{' '}
            <strong> etapas abaixo para o envio da receita médica:</strong>
          </p>
        </div>
      </Modal.Header>
      <Modal.Body
        className="pt-3 d-flex align-items-center"
        style={{
          paddingLeft: '2rem',
          fontFamily: 'Montserrat, sans-serif',
        }}
      >
        <StepperFabric steps={steps} />
      </Modal.Body>
      <Modal.Footer className="px-4 pb-4 pt-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        <div className="w-100">
          <button
            className="btn btn-primary w-100 px-2 py-3"
            onClick={() => {
              addToCart();
              onHide();
            }}
            style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700 }}
          >
            Adicionar ao carrinho
          </button>
        </div>
      </Modal.Footer>
    </CustomModal>
  );
}
